import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledMenuItem = styled.div`
  position: relative;

  > a,
  > button {
    ${themeGet('font.whitneySemibold')}
    padding: ${themeGet('scale.scaleUp03')};
    background: none;
    border: none;
    font-size: ${themeGet('scale.scaleUp01')};
    color: #1F304C;
    display: block;
    width: 100%;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    position: relative;
    vertical-align: middle;

    > svg {
      width: auto;
      height: 9px;
      position: absolute;
      right: ${themeGet('scale.scaleUp03')};
      top: 50%;
      margin-top: -4px;
    }
  }

  &.is-open > button,
  &.is-active > button,
  &.is-active > a {
    background: ${themeGet('color.colorGrayBlue30')};
    color: ${themeGet('color.colorBlue60')};

    > svg path {
      fill: ${themeGet('color.colorBlue60')};
    }
  }

  &.is-open > button {
    position: sticky;
    top: calc(${themeGet('scale.scaleUp03')} * 3);
    z-index: ${themeGet('zIndex.zIndex01')};

    > svg {
      transform: rotate(180deg);
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    > a,
    > button {
      font-size: ${themeGet('scale.scaleUp02')};
      padding: ${themeGet('scale.scaleUp05')} ${themeGet('scale.scaleUp07')};

      > svg {
        right: ${themeGet('scale.scaleUp07')};
      }
    }

    &.is-open > button {
      top: calc(
        ${themeGet('scale.scaleUp06')} * 2
        + ${themeGet('scale.scaleUp05')}
      );
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    align-content: center;
    position: static;
    margin-right: ${themeGet('scale.scaleUp02')};
    height: 100%;
    
    > a,
    > button {
      height: 100%;
      padding: 0;
      display: flex;
      align-items: center;
      font-size: ${themeGet('scale.scaleDown01')};
      padding-top: ${themeGet('scale.scaleDown04')};
      border-bottom: ${themeGet('scale.scaleDown04')} solid transparent;
    }

    > button {
      > svg {
        right: 0;
        height: 5px;
        margin-top: 0;
      }
    }

    button:hover,
    a:hover,
    &.is-open > button,
    &.is-active > button,
    &.is-active > a {
      background: none;
      border-bottom-color: ${themeGet('color.colorBlue50')};
      color: ${themeGet('color.colorBlue50')};
    }

    &.is-open > button {
      position: relative;
      top: 0;
      border-bottom-color: transparent;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavLg')}) {
    > a,
    > button {
      font-size: ${themeGet('scale.scaleBase')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavXl')}) {
    margin-right: ${themeGet('scale.scaleUp05')};
  }
`;

export default StyledMenuItem;
